import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { Box, HStack, Text, useTheme } from "native-base";
import { getServiceColour, serviceForHumans } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import { useRouteNavigate } from "../../providers/routing";
import useResponsive from "../../util/useResponsive";
import Badge from "../../atoms/Badge";
import Headline from "../../molecules/Headline";
import Paper from "../../atoms/Paper";
import SearchInput from "../../molecules/Form/SearchInput";
import AvatarTexts from "../../molecules/AvatarTexts";
import Tooltip from "../../atoms/Tooltip";
import Icon from "../../icons/Icon";
import Tag from "../../atoms/Tag";
import ReactTable from "../../molecules/ReactTable";
import CallCenterPatientsDesktopFilter from "../../organisms/filters/desktop/CallCenterPatientsDesktopFilter";
import CallCenterPatientsMobileFilter from "../../organisms/filters/mobile/CallCenterPatientsMobileFilter";
import { usePatients } from "../../providers/patient";
const CallCenterPatients = ({ onEndReached }) => {
    const [search, setSearch] = useState("");
    const { patients, onSortChange, pagination, onSearchChange } = usePatients();
    const navigate = useRouteNavigate();
    const { t } = useTranslation();
    const { colors } = useTheme();
    const { isSmallScreen } = useResponsive();
    const handleSearchChange = (search) => {
        setSearch(search);
        onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange(search);
    };
    const handleRowPress = ({ userId }) => {
        navigate("patient", { patientId: userId });
    };
    const columns = useMemo(() => [
        {
            Header: t("patientName"),
            accessor: "fullName",
            defaultCanSort: !!onSortChange,
            width: "auto",
            Cell: ({ row }) => {
                const { fullName, initials, avatarUrl } = row.original;
                return (_jsx(AvatarTexts, { initials: initials, label: fullName, source: avatarUrl }));
            },
        },
        {
            Header: () => (_jsxs(HStack, Object.assign({ alignItems: "center" }, { children: [_jsx(Text, { children: t("package") }), _jsx(Tooltip, Object.assign({ hasArrow: true, label: t("doctor:packageLabelDescription"), placement: "right" }, { children: _jsx(Box, Object.assign({ ml: 2 }, { children: _jsx(Icon, { name: "help", size: 14, fill: colors.gray[600] }) })) }))] }))),
            accessor: "services",
            width: "20%",
            Cell: ({ value: services }) => (_jsx(HStack, Object.assign({ space: 1 }, { children: services.map((service) => (_jsx(Tag, Object.assign({ variant: getServiceColour(service) }, { children: serviceForHumans(service) }), service))) }))),
            disableSortBy: true,
        },
        {
            Header: t("numberOfDevices"),
            accessor: "deviceCount",
            width: 144,
            disableSortBy: true,
        },
    ], [colors, onSortChange, t]);
    return (_jsx(_Fragment, { children: _jsxs(Paper, { children: [_jsx(Headline, { minHeight: 12, borderBottomWidth: 1, borderBottomColor: "gray.100", borderBottomStyle: "solid", title: t("patients"), accessory: _jsx(Badge, Object.assign({ hasIndicator: false, variant: "ghost" }, { children: pagination.totalCount })) }), _jsx(Headline, { leftContent: isSmallScreen ? (_jsx(SearchInput, { ml: "auto", size: "sm", value: search, onChangeText: handleSearchChange })) : (_jsx(CallCenterPatientsDesktopFilter, {})), rightContent: isSmallScreen ? (_jsx(CallCenterPatientsMobileFilter, {})) : (_jsx(SearchInput, { ml: "auto", size: "sm", value: search, onChangeText: handleSearchChange })) }), _jsx(Box, Object.assign({ px: 6, pb: 1, width: "full" }, { children: _jsx(ReactTable, { columns: columns, data: patients, onSortChange: onSortChange, onEndReached: onEndReached, onPress: handleRowPress }) }))] }) }));
};
export default CallCenterPatients;
